/**
 * screen.ts — Direção de arte por tamanho de tela (Fase 7)
 *
 * Acrescenta a TODO bloco já registrado duas propriedades avançadas:
 *  - "Aparece em": em quais tamanhos de tela (e na impressão) o bloco existe;
 *  - "Ordem": posição do bloco dentro da faixa, podendo variar por tela — é o
 *    que permite, por exemplo, a imagem vir antes do texto só no celular.
 *
 * Como é aplicado sobre o catálogo pronto, não há lista duplicada: qualquer
 * bloco novo passa a ter as mesmas opções assim que este módulo é importado
 * (sempre por último, em `src/lib/studio/core/index.ts`).
 *
 * RELEASE: v1.0.0 - 2026-09-11 - Versão inicial (motor de composições, Fase 7)
 */

import { listBlocks, registerBlock } from '../blockRegistry';
import { STUDIO_SCREEN_OPTIONS, STUDIO_SCREEN_ORDER_OPTIONS } from '../screen';
import type { StudioBlockProp } from '../types';

/** Em quais tamanhos de tela o bloco aparece. */
export const VISIBILIDADE: StudioBlockProp = {
  key: 'showOn',
  label: 'Aparece em',
  type: 'select',
  defaultValue: 'all',
  advanced: true,
  options: STUDIO_SCREEN_OPTIONS,
  help: 'Permite ter uma versão do bloco para o computador e outra para o celular.',
};

/** Ordem do bloco dentro da faixa, ajustável por tamanho de tela. */
export const ORDEM: StudioBlockProp = {
  key: 'order',
  label: 'Ordem',
  type: 'responsive',
  advanced: true,
  of: {
    label: 'Ordem',
    type: 'select',
    options: STUDIO_SCREEN_ORDER_OPTIONS,
  },
  help: 'Troca a sequência dos blocos sem mexer no conteúdo (ex.: imagem antes do texto no celular).',
};

/** Aplica as propriedades de tela a todos os blocos já registrados. */
export function aplicarPropriedadesDeTela(): void {
  listBlocks().forEach((definicao) => {
    if (definicao.props.some((p) => p.key === 'showOn')) return;
    registerBlock({ ...definicao, props: [...definicao.props, VISIBILIDADE, ORDEM] });
  });
}

aplicarPropriedadesDeTela();
